// @flow
import React, { PureComponent } from 'react';
import Label from 'components/fragments/text/Label';
import type { CategoryType } from 'types/Article';


export type StateProps = {
  categories: Array<CategoryType>
};

class Themes extends PureComponent<StateProps>{

  renderThemeList = () => {
    const { categories } = this.props;

    return categories.map<any>((category, index) => (
      <li key={index}>
        <Label label={category.name} link={`/actualites/${category.slug}`} />
      </li>
    ));
  }

  render(){
    return (
      <div className="row">
        <div className="col col-lg-8on9">
          <div className="box box--grey block-label mb-6 mb-md-7">
            <p className="ft-500">Par thématiques :</p>
            <ul>{this.renderThemeList()}</ul>
          </div>
        </div>
      </div>
    );
  }
}


export default Themes;
